<template lang="pug">
.colorbar-careers-hero
  section.row.row-full.hero
    .row.row-full
      responsive-image.xs-hide.sm-hide(:media-obj="bgImage")
    .heroCopy
      h1.f-secondary.xs-f-grande.md-f-xxxgrande.max-at-tweak(v-html="title")
      h2.f-primary.upper.xs-f-medium.md-f-large.max-at-tweak(v-html="subtitle")
      p.f-primary.xs-f-medium.max-at-tweak(v-html="text")

      .row.button-row
        a.play-button-wrapper.mr-btn.xs-hide.sm-hide(alt="play button" @click="onModalShow")
          .play-button
            svg(viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg")
              circle(cx="32" cy="32" r="30.5" stroke="white" stroke-width="3")
              path(d="M49 32.25L22 16.5V48L49 32.25Z" fill="white")
            .inner-text Play Video

        a.mr-btn.viewOpenings(@click="scrollTo('.searchJobs', 600)") View Openings

  focus-lock.modal-body(v-show="modalIsShowing" ref="modalBody" role="dialog" aria-modal="true")
    button.btn-close.transparent-btn.xs-f-large.max-at-tweak(type="button" alt="Close modal" aria-label="Close modal" data-mr-ass="close-modal" @click.prevent="onModalHide")
      span.icon-x

    video.fullpageVideo(v-if="modalIsShowing" height="auto" width="100%" controls autoplay preload="metadata")
      source(:src="`${video.url}?fm=webm`" type='video/webm')
      source(:src="`${video.url}?fm=mp4`" type='video/mp4')

  video.md-hide.lg-hide(height="auto" width="100%" controls preload="metadata" :poster="videoPosterImage.url")
    source(:src="`${video.url}?fm=webm`" type='video/webm')
    source(:src="`${video.url}?fm=mp4`" type='video/mp4')
</template>

<script>
  import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock-upgrade";

  export default {

    name: 'HCBCareersHero',

    props: {
      title: {
        type: String,
        default: ''
      },
      subtitle: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''
      },
      videoPosterImage: {
        type: Object,
        default() {
          return {};
        }
      },
      bgImage: {
        required: true,
        type: Object
      },
      video: {
        required: true,
        type: Object
      }
    },

    data() {
      return {
        modalIsShowing: false,
        previousAppModalDisabledClose: undefined,
      };
    },

    unmounted() {
      clearAllBodyScrollLocks();
    },

    methods: {
      onModalHide() {
        this.modalIsShowing = false;

        enableBodyScroll(this.$refs.modalBody);
      },

      onModalShow() {
        this.modalIsShowing = true;

        disableBodyScroll(this.$refs.modalBody, {
          reserveScrollBarGap: true,
          allowTouchMove: el => {
            while (el && el !== document.body) {
              if (el.getAttribute('body-scroll-lock-ignore') !== null) {
                return true;
              }
              el = el.parentNode;
            }
          }
        });
      },
    },

  };
</script>

<style lang="stylus">
.colorbar-careers-hero

  @media mq-tablet-less
    margin-bottom -3px

  .hero
    position relative
    display block

  .modal-body
    position fixed
    top 0
    bottom 0
    left 0
    right 0
    z-index 1000000

    .btn-close
      color white
      position fixed
      right 0
      margin 10px
      cursor pointer
      z-index 10

    .fullpageVideo
      width 100%

  .heroCopy
    position absolute
    left 6.25%
    top 50%
    transform translateY(-50%)
    max-width 42.7%
    background-color rgba(255, 255, 255, 0.8)
    padding 30px

    @media (max-width 1225px)
      left 12.5%
      max-width 75%

    @media mq-tablet-less
      position static
      text-align center
      max-width 100%
      margin unset
      margin-top 0px
      background-color rgba(0,0,0,0.1)
      transform unset

    .button-row
      margin-top 40px

    .play-button-wrapper
      .play-button

        svg
          height 20px
          margin-right 8px

        .inner-text
          float right
          margin-top 1.5%

    h2
      margin-bottom 25px
      color color-mister-darker-gray

      @media mq-tablet-less
        margin 20px 0px
    h1
      color color-mr-purple

    p
      text-transform none
      color color-mister-darker-gray

  .row-full
    max-width 100%

  .video
    max-height 100vh

  .viewOpenings
    padding 1.17em 2em
    color cta-color-1
    background-color transparent
    border 2px solid cta-color-1

    &:hover
      border-color #831678
      color #831678

    @media mq-tablet-plus
      margin-left 30px
</style>
